import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import swal from "sweetalert";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg";
import { ReactComponent as PlusWhite } from "../../assets/icons/whitePlus.svg";
import { ReactComponent as LeftArrowIcon } from "../../assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../assets/icons/dot.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import DifferenceRemarksModal from "./DifferenceRemarksModal";
import FilterModal from "./FilterModal";
import { getInterCompanyReconcilationApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const filterOptions = [
  {
    name: "My User",
    type: "people",
    fieldType: "Custom",
    key: "68da6c4a4b78aec1ee742624",
    filterTypes: ["include", "exclude"],
  },
  {
    name: "My Tags",
    type: "tag",
    fieldType: "Custom",
    key: "68db6813d3413bfab6cfb00f",
    filterTypes: ["contains", "starts with", "does not contain"],
  },
  {
    name: "Assignee",
    type: "people",
    fieldType: "Default",
    key: "assigneeIDs",
    filterTypes: ["include", "exclude"],
  },
  {
    name: "Approver",
    type: "people",
    fieldType: "Default",
    key: "approverID",
    filterTypes: ["include", "exclude"],
  },
  {
    name: "Module",
    type: "shortText",
    fieldType: "Default",
    key: "module",
    filterTypes: ["contains", "starts with", "does not contain"],
  },
  {
    name: "Due Date",
    type: "date",
    fieldType: "Default",
    key: "dueDate",
    filterTypes: ["less than", "equal to", "greater than"],
  },
  {
    name: "Status",
    type: "shortText",
    fieldType: "Default",
    key: "status",
    filterTypes: ["contains", "starts with", "does not contain"],
  },
];

const PerformReconciliation = ({ setEliminationScreen, consolID, setSelectedReconciliationRow }) => {
  const [activePopover, setActivePopover] = useState(null);
  const [popoverPos, setPopoverPos] = useState({ x: 0, y: 0 });

  const [remarksModalOpen, setRemarksModalOpen] = useState(false);
  const [remarksModalType, setRemarksModalType] = useState(null);
  const [selectedRemarkData, setSelectedRemarkData] = useState(null);

  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const [reconciliationData, setReconciliationData] = useState([]);
  const [activeYearTab, setActiveYearTab] = useState("currentYear");
  useEffect(() => {
    getInterCompanyReconcilation();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(`.${icrCss.popover}`)) {
        setActivePopover(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getInterCompanyReconcilation = () => {
    getInterCompanyReconcilationApiHandler({
      consolID: consolID,
    })
      .then((res) => {
        if (res?.data?.success) {
          const RESP = res?.data;
          setReconciliationData(RESP?.reconciliationData ?? []);
        } else {
          swal("Error", "Unable to get intercompany reconciliation", "error");
        }
      })
      .catch(() => {
        swal("Error", "Unable to populate intercompany reconciliation", "error");
      });
  };

  const togglePopover = (blockIndex, rowIndex, e) => {
    const key = `${blockIndex}-${rowIndex}`;
    if (activePopover === key) {
      setActivePopover(null);
    } else {
      const rect = e.target.getBoundingClientRect();
      setPopoverPos({ x: rect.right, y: rect.bottom });
      setActivePopover(key);
    }
  };

  const handleRemarksModalClose = () => {
    setRemarksModalOpen(false);
    setRemarksModalType(null);
    setSelectedRemarkData(null);
  };

  const handleRemarksClick = (row) => {
    if (row.remarks) {
      setRemarksModalType("view");
    } else {
      setRemarksModalType("add");
    }
    setSelectedRemarkData(row);
    setRemarksModalOpen(true);
  };

  const handleFilterModalClose = () => {
    setFilterModalOpen(false);
  };

  return (
    <>
      <div className={icrCss.header}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            fontSize: "14px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setEliminationScreen(0)}
          >
            <span style={{ cursor: "pointer" }}>
              <LeftArrowIcon
                height={12}
                style={{ marginBottom: "2px" }}
                onClick={() => setEliminationScreen(0)}
              />
            </span>
            <span style={{ color: "#4D6D64", marginLeft: "10px" }}>
              Inter company elimination
            </span>
          </span>
          <span>
            <DotIcon />
          </span>
          <span
            style={{ color: "#4D6D64", cursor: "pointer" }}
            onClick={() => setEliminationScreen(1)}
          >
            View workings
          </span>
          <span>
            <DotIcon />
          </span>
          <span>Perform reconciliation</span>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            fontSize: "10px",
            padding: "10px 0 10px 10px",
          }}
        >
          <div className={icrCss.performReconciliationFilterCtn}>
            <div className={icrCss.filterItemBadge}>
              <span>Identifier - relative -</span>
              <span>value</span>
            </div>
            <div className={icrCss.filterItemBadge}>
              <span>Identifier - relative -</span>
              <span>value</span>
            </div>
            <div className={icrCss.filterItemBadge}>
              <span>Identifier - relative -</span>
              <span>value</span>
            </div>
            <div className={icrCss.filterItemBadge}>
              <span>Identifier - relative -</span>
              <span>value</span>
            </div>
          </div>

          <FilterIcon
            style={{ cursor: "pointer" }}
            onClick={() => setFilterModalOpen(true)}
          />

          <Button
            icon={<PlusWhite />}
            btnColor={buttoncss.primary}
            label="Add Entry"
          />
        </div>
      </div>

  
    <div style={{ display: "flex", justifyContent: "center", padding: "14px 20px 0 20px" }}>
      <div
        style={{
          display: "inline-flex",
          border: "1px solid #205A46",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <button
          onClick={() => setActiveYearTab("currentYear")}
          style={{
            padding: "12px 20px",
            border: "none",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "500",
            backgroundColor: activeYearTab === "currentYear" ? "#205A46" : "transparent",
            color: activeYearTab === "currentYear" ? "#fff" : "#205A46",
            borderRight: "1px solid #205A46",
            lineHeight: 1,
          }}
        >
          Current Year
        </button>
        <button
          onClick={() => setActiveYearTab("previousYear")}
          style={{
            padding: "12px 20px",
            border: "none",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "500",
            backgroundColor: activeYearTab === "previousYear" ? "#205A46" : "transparent",
            color: activeYearTab === "previousYear" ? "#fff" : "#205A46",
            lineHeight: 1,
          }}
        >
          Previous Year
        </button>
      </div>
    </div>

      <div className={icrCss.comparisonGrid}>
        {reconciliationData.length > 0 &&
        reconciliationData.map((block, blockIndex) => {
            const tableRows =
              block[activeYearTab]?.reconciliationTable ?? [];

            return (
              <div key={blockIndex} className={icrCss.comparisonCard}>
                <div className={icrCss.comparisonCardHeader}>
                  <span>
                    {block.parentCompany} - {block.subsidiaryCompany}
                  </span>
                  <Button
                    class_={icrCss.comparisonCardHeaderBtn}
                    btnColor={buttoncss.primary}
                    label="Export"
                  />
                </div>
                <div className={icrCss.comparisonTableWrapper}>
                  <table className={icrCss.comparisonTable}>
                    <thead>
                      <tr>
                        <th>{block.parentCompany}</th>
                        <th>{block.subsidiaryCompany}</th>
                        <th>Difference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableRows.map((row, i) => {
                        // const isDifferenceClickable =
                        //   row.difference !== null &&
                        //   Number(row.difference) !== 0;
                        const isDifferenceClickable = row.difference !== null;

                        const popoverKey = `${blockIndex}-${i}`;

                        return (
                          <tr key={i}>
                            <td>
                              {row.parentCompany.map((item, j) => (
                                <div
                                  key={j}
                                  className={icrCss.comparisionTableRowItem}
                                >
                                  <span className={icrCss.particular}>
                                    {item.particular}
                                  </span>
                                  <span className={icrCss.amount}>
                                    {item.amount !== null && item.amount !== undefined
                                      ? (Number(item.amount) < 0
                                          ? `(${Math.abs(Number(item.amount)).toLocaleString("en-IN")})`
                                          : Number(item.amount).toLocaleString("en-IN"))
                                      : ""}
                                  </span>
                                </div>
                              ))}
                            </td>

                            <td>
                              {row.subsidiaryCompany.map((item, j) => (
                                <div
                                  key={j}
                                  className={icrCss.comparisionTableRowItem}
                                >
                                  <span className={icrCss.particular}>
                                    {item.particular}
                                  </span>
                                  <span className={icrCss.amount}>
                                   {item.amount !== null && item.amount !== undefined
                                    ? (Number(item.amount) < 0
                                        ? `(${Math.abs(Number(item.amount)).toLocaleString("en-IN")})`
                                        : Number(item.amount).toLocaleString("en-IN"))
                                    : ""}
                                  </span>
                                </div>
                              ))}
                            </td>

                            <td
                              className={
                                isDifferenceClickable
                                  ? icrCss.differenceCell
                                  : icrCss.differenceDefaultCell
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!isDifferenceClickable) return;
                                togglePopover(blockIndex, i, e);
                              }}
                              style={{
                                cursor: isDifferenceClickable
                                  ? "pointer"
                                  : "default",
                              }}
                            >
                            {row.difference !== null && row.difference !== undefined
                              ? (Number(row.difference) < 0
                                  ? `(${Math.abs(Number(row.difference)).toLocaleString("en-IN")})`
                                  : Number(row.difference).toLocaleString("en-IN"))
                              : ""}

                              {isDifferenceClickable &&
                                activePopover === popoverKey &&
                                createPortal(
                                  <div
                                    className={icrCss.popover}
                                    style={{
                                      position: "absolute",
                                      top: popoverPos.y - 10,
                                      left: popoverPos.x - 180,
                                    }}
                                  >
                                    {/* <Button
                                      btnColor={buttoncss.primary}
                                      label="View Reconciliation"
                                      onClick={() => setEliminationScreen(3)}
                                    /> */}

                                    <Button
                                      label="View Reconciliation"
                                      btnColor={buttoncss.primary}
                                      onClick={() => {
                                        setSelectedReconciliationRow({
                                          configIndex: row.configIndex,
                                          parentCompanyID: block.parentCompanyID,
                                          subsidiaryCompanyID: block.subsidiaryCompanyID,
                                        });
                                        setEliminationScreen(3);
                                      }}
                                    />
                                  {row.remarks ? (
                                    <Button
                                      btnColor={buttoncss.secondary}
                                      label="View Remarks"
                                      onClick={() => handleRemarksClick(row)}
                                    />
                                  ) : (
                                    <Button
                                      icon={<PlusPrimary />}
                                      btnColor={buttoncss.secondary}
                                      label="Add Remarks"
                                      onClick={() => handleRemarksClick(row)}
                                    />
                                  )}
                                </div>,
                                document.body,
                              )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            );
        })}
      </div>
      {remarksModalOpen && (
        <DifferenceRemarksModal
          handleClose={handleRemarksModalClose}
          type={remarksModalType}
          data={selectedRemarkData}
        />
      )}

      {filterModalOpen && (
        <FilterModal
          filterAttr={filterOptions}
          handleClose={handleFilterModalClose}
        />
      )}
    </>
  );
};

export default PerformReconciliation;